import React from "react";
import { Flex, Text, HStack, Image, Box } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bmLogo from "../../assets/svg/bm_logo.svg";
import HeaderLinks from "./AdminNavbarLinks";
import { useAuth } from "../../context/AuthContext";

export default function MainNavbar() {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="0.5rem 1rem"
      bg="rgba(26, 31, 55, 0.65)"
      backdropFilter="blur(12px)"
      css={{ WebkitBackdropFilter: "blur(12px)" }}
      color="white"
      borderBottom="1px solid"
      borderColor="whiteAlpha.200"
      position="sticky"
      top="0"
      zIndex="sticky"
      boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)"
    >
      {/* LEFT SIDE: Logo + Links */}
      <HStack spacing={8} alignItems="center">
        <RouterLink to="/dashboard">
          <Image src={bmLogo} h="30px" alt="BulletMonkey" />
        </RouterLink>

        <HStack spacing={6} display={{ base: "none", md: "flex" }}>
          <RouterLink to="/dashboard"> 
            <Text 
              fontWeight="medium" 
              _hover={{ color: "teal.300" }}
              transition="color 0.2s"
            >
              {t('projectsLink')}
            </Text>
          </RouterLink>
          {isAdmin && (
            <RouterLink to="/admin"> 
                <Text 
                fontWeight="medium" 
                _hover={{ color: "teal.300" }}
                transition="color 0.2s"
                color="purple.300"
                >
                Admin
                </Text>
            </RouterLink>
          )}
        </HStack>
      </HStack>

      {/* RIGHT SIDE: User Menu & Lang */}
      <Box>
        <HeaderLinks />
      </Box>
    </Flex>
  );
}
